module.exports = __webpack_public_path__ + "static/media/profile.76cad9c9.svg";